import {
  GENERATE_KEYWORDS_START,
  GENERATE_KEYWORDS_SUCCESS,
  GENERATE_KEYWORDS_FAILED,
  GENERATE_HEADINGS_START,
  GENERATE_HEADINGS_SUCCESS,
  GENERATE_HEADINGS_FAILED,

  GENERATE_DESCRIPTION_START,
  GENERATE_DESCRIPTION_SUCCESS,
  GENERATE_DESCRIPTION_FAILED,


  CLEAR_AI_REDUCER
} from "../store/types";

import { cloud_function_server_url } from "config";

import { MarketingPrompt } from '../../AI_Prompts/Markerting_Headers_descriptions';
import { KeyWordsPrompt } from "../../AI_Prompts/Key_Words";

export const GenerateListingKeywords = (ListingData) => (dispatch) => async (firebase) => {
  try {
    dispatch({
      type: GENERATE_KEYWORDS_START,
      payload: null,
    });

    if (!ListingData) throw new Error("No listing data provided");


    const listingDataString = JSON.stringify(ListingData);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      model: "llama3.1",
      temperature: 0,      // 🔹 deterministic output
      messages: [
        {
          role: "system",
          content: "You are a marketing director"
        },
        {
          role: "user",
          content: KeyWordsPrompt(listingDataString)
        }
      ],
      stream: false
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/requestFromAi`, requestOptions)
      .then((response) => response.json())
      .then((result) => {


        console.log('result', result)

        let content = JSON.parse(result.message.content);


        console.log('content', content)

        if (content) {
          dispatch({ type: GENERATE_KEYWORDS_SUCCESS, payload: { keywords: content.keywords } });
        }

      })
      .catch((error) => {
        console.error("Error generating keywords:", error);
        dispatch({ type: GENERATE_KEYWORDS_FAILED, payload: { error: error.message || String(error) } });
      });



  } catch (error) {
    dispatch({
      type: GENERATE_KEYWORDS_FAILED,
      payload: error.message || String(error),
    });
  }
};



export const clearAiReducer = (ListingData) => (dispatch) => (firebase) => {
  dispatch({ type: CLEAR_AI_REDUCER });
};




export const GenerateListingDescription = (ListingData) => (dispatch) => (firebase) => {
  //const { ListingOfficeRef, auth } = firebase;
  try {
    // dispatch start action if you want a loading state
    dispatch({
      type: GENERATE_DESCRIPTION_START,
      payload: null
    });

    if (!ListingData) throw new Error("No listing data provided");


    const listingDataString = JSON.stringify(ListingData);





    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");


    //    const raw = "{\n  \"model\": \"llama3.1\", \n  \"messages\": [\n    {\n      \"role\": \"system\", \n      \"content\": \"you are a marketing director\" \n    },\n    {\n      \"role\": \"user\", \n      \"content\": \"Desribe the property for rent from the following information. Stand alone industrial facility to let in Meadowdale Free standing industrial facility measuring 9,000sqm set on a 9,900sqm stand offering fantastic R24 highway exposure. The warehouse measures 5,340sqm with a 2,412sqm triple volume office component and 1,254sqm storage mezzanine level. The property is highly secure with electric fencing surrounding the entire perimeter.The warehouse has a sprinkler system, great height of 11m to the eaves and there's multiple roller shutter doors allowing for quick and easy access. There's great natural lighting that flows through the entire space and ample secure staff and visitor parking bays present. Rental is R50/sqm therefore asking R450 000 per month excluding VAT and utilities. Triple net lease\" \n    }\n  ],\n  \"stream\": false \n}/\n";


    const raw = JSON.stringify({
      model: "llama3.1",
      temperature: 0,      // 🔹 deterministic output
      messages: [
        {
          role: "system",
          content: "You are a marketing director"
        },
        {
          role: "user",
          content: MarketingPrompt(listingDataString)
        }
      ],
      stream: false
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/requestFromAi`, requestOptions)
      .then((response) => response.json())
      .then((result) => {


        console.log('result', result)

        let content = JSON.parse(result.message.content);
        if (content) {
          dispatch({ type: GENERATE_DESCRIPTION_SUCCESS, payload: { description: content.description, title: content.title } });
        }

      })
      .catch((error) => {
        console.error("Error generating description:", error);
        dispatch({ type: GENERATE_DESCRIPTION_FAILED, payload: { error: error.message || String(error) } });
      });

  } catch (error) {
    // dispatch fail
    dispatch({ type: GENERATE_DESCRIPTION_FAILED, payload: { error: error.message || String(error) } });
    console.error("Error generating description:", error);
  }
};
